<div
  *ngIf="allgames?.live?.length || allgames?.upcoming?.length"
  class="bg-white rounded-10 custom-shadow overflow-hidden mb-4 expert_picks_sidebar"
>
  <div
    class="side-table-view-heading p-3 bg-blue-gradient text-white d-flex justify-content-between align-items-center"
  >
    <span> Expert Picks </span>
    <div class="d-flex align-items-center justify-content-end">
      <input
        matInput
        [matDatepicker]="picker"
        (dateChange)="changeDate($event)"
        style="visibility: hidden"
        [max]="currentDate"
        [value]="date"
      />
      Select Date
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </div>
  </div>
  <!-- tabs section start -->
  <ul
    class="list-inline filter-tabs-area py-3 text-center m-0"
    style="padding-bottom: 0px !important"
  >
    <ng-container *ngIf="!date || date > currentDate; else datetab">
      <li class="list-inline-item">
        <button
          id="pills-expert-tab"
          [class.active]="upcoming"
          (click)="upcoming = true"
          >Upcoming Games</button
        >
      </li>
      <li class="list-inline-item">
        <button
          id="pills-live-game-tab"
          [class.active]="!upcoming"
          (click)="upcoming = false"
          >Live Games</button
        >
      </li>
    </ng-container>
    <ng-template #datetab>
      <li class="list-inline-item">
        <span id="pills-expert-tab-games" class="active">Games</span>
      </li>
    </ng-template>
  </ul>
  <!-- tabs section end -->
  <div class="side-table-view-heading p-3 m-0">
    <div
      class="row pt-2 g-2"
      *ngIf="allgames[upcoming ? 'upcoming' : 'live']?.length; else noGames"
    >
      <div class="mt-0 col-auto w-70px">Date</div>
      <div class="mt-0 col">Game</div>
    </div>
    <div
      *ngIf="!allgames[upcoming ? 'upcoming' : 'live']?.length"
      class="text-center"
    >
      No games available
    </div>
  </div>
  <ng-container
    *ngFor="let game of allgames[upcoming ? 'upcoming' : 'live']; index as i"
  >
    <div
      class="c-pointer top-winner-list-item mb-3 py-2"
      [class.top-lock-highlight]="game.lock_pick"
      [class.upcoming-general-active]="
        _activated.snapshot.params.slug == game.slug ||
        selectedGame == game.slug
      "
    >
      <!-- (click)="changeGame(game,i)" [routerLink]='["/",selectedSport?.toLowerCase(),"expert-picks",(game.name?.toLowerCase() | replace:" ":"-")+"-"+i]' -->
      <a
        class="row px-3 gx-2"
        [routerLink]="[
          '/',
          selectedSport?.toLowerCase(),
          'expert-picks',
          game.utc_match_date | date:'dd',
          game.utc_match_date | date:'MM',
          game.utc_match_date | date:'YYYY',
          game.slug+'|'+game.sport
        ]"
      >
        <div class="col-12 text-end top-winner-lock">
          <span class="text-f10">{{ game.lock_pick }} Lock Pick</span>
        </div>
        <div class="mt-0 col-auto w-70px align-self-center">
          <div class="top-winner-datetime text-muted">
            {{ game.utc_match_date |date:'dd-MMM-YY hh:mm a' }}
          </div>
        </div>
        <div class="mt-0 col align-self-center">
          <div class="sidebar-winning-amt">
            {{ game.name }}
          </div>
        </div>
        <div
          class="mt-0 col-auto sidebar-rank-number text-primary align-self-center"
        >
          <strong>{{
            game.betCount > 1
              ? game.betCount + " Picks"
              : game.betCount + " Pick"
          }}</strong>
        </div>
      </a>
    </div>
  </ng-container>
  <div
    class="top-winner-list-item"
    style="box-shadow: none !important"
    *ngIf="!hideLoadMore"
  >
    <div class="row px-3 g-3 my-3">
      <div class="col-12 mt-0 text-end">
        <a [routerLink]="['/',selectedSport?.toLowerCase(),'expert-picks']" class="small text-decoration-none"
          >Load More</a
        >
      </div>
    </div>
  </div>
</div>
